import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import CustomerReportMain from "./component/CustomerDetailReportMain";
import CustomerDetailReportMain from "./component/CustomerDetailReportMain";

const title = "Customer Details";

const CustomerDetailReportMainPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <CustomerDetailReportMain />;
};

export default CustomerDetailReportMainPage;
